module.exports = __webpack_public_path__ + "media/confirm_style_1_echo_001.ab05f3d8.mp3";